import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { API, AuthSignIn, AXIOS, clearToken, clearUser, CommonGlobalService, LoggerService, RootState, saveToken, saveUser, UserUmanforge, getAppsFromMask, APPS_NAME, configService } from '@umanforge/common';
import { AxiosHeaders, AxiosResponse } from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
//import FictiveData from 'pages/fictiveData.page';
//import FictiveData from 'pages/data.page';
import Setting from 'pages/setting.page';
import Chart from 'pages/chart.page';
import Chronogram from 'features/chronogram/views/chronogram.page';
import PlanningPage from 'features/planning/views/planning.view';
import { VERSION } from 'constants/app.constants';
import TimeGridView from 'pages/timegrid.page';


const logger: LoggerService = new LoggerService( 'App' );

export function App() {

  const dispatch = useDispatch();
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );

  useEffect( () => {
    logger.verbose( 'Version :', VERSION );
  }, [] );

  useEffect( () => {
    const urlParams = new URLSearchParams( window.location.search );
    const umanforge = urlParams.get( 'umanforge' );
    if ( umanforge != null && umanforge != '' ) {
      window.history.pushState( {}, document.title, window.location.pathname );
    }
    if ( !token ) {
      AXIOS.get( API.IS_SIGN_IN )
        .then( async ( response: AxiosResponse ) => {
          let connected = false;
          let user: UserUmanforge | null = null;
          let newToken: string | null = null;
          if ( response.status === 200 ) {
            const result = response.data as AuthSignIn;
            newToken = ( response.headers as AxiosHeaders ).get( 'auth-token' ) as string;
            user = result.user as UserUmanforge;
            connected = result.signin;
          }
          if ( !connected || user == null || user.needChangePassword ) {
            dispatch( clearToken() );
            dispatch( clearUser() );
            CommonGlobalService.openAuthPage();
          } else {
            const mask = Number( ( user as unknown as Record<string, unknown> ).appAccess ?? ( user as unknown as Record<string, unknown> ).app_access ?? 15 );
            const allowedApps = getAppsFromMask( mask );
            const hasPlaniteamAccess = allowedApps.includes( APPS_NAME.PLANITEAM );
            if ( !hasPlaniteamAccess ) {
              const umanforgeUrl = await configService.getUmanforgeUrl();
              window.location.href = String( umanforgeUrl );
              return;
            }
            dispatch( saveToken( newToken as string ) );
            dispatch( saveUser( user as UserUmanforge ) );
          }
        } )
        .catch( () => { CommonGlobalService.openAuthPage(); } );
    }
  } );

  useEffect( () => {
    const checkUserConnection = () => {
      if ( !document.hidden ) {
        AXIOS.get( API.IS_SIGN_IN )
          .then( async ( response: AxiosResponse ) => {
            let connected = false;
            let user: UserUmanforge | null = null;
            let newToken: string | null = null;
            if ( response.status === 200 ) {
              const result = response.data as AuthSignIn;
              newToken = ( response.headers as AxiosHeaders ).get( 'auth-token' ) as string;
              user = result.user as UserUmanforge;
              connected = result.signin;
            }
            if ( !connected || user == null || user.needChangePassword ) {
              dispatch( clearToken() );
              dispatch( clearUser() );
              CommonGlobalService.openAuthPage();
            } else {
              const mask = Number( ( user as unknown as Record<string, unknown> ).appAccess ?? ( user as unknown as Record<string, unknown> ).app_access ?? 15 );
              const allowedApps = getAppsFromMask( mask );
              const hasPlaniteamAccess = allowedApps.includes( APPS_NAME.PLANITEAM );
              if ( !hasPlaniteamAccess ) {
                const umanforgeUrl = await configService.getUmanforgeUrl();
                window.location.href = String( umanforgeUrl );
                return;
              }
              dispatch( saveToken( newToken as string ) );
              dispatch( saveUser( user as UserUmanforge ) );
            }
          } )
          .catch( () => {
            CommonGlobalService.openAuthPage();
          } );
      }
    };

    document.addEventListener( 'visibilitychange', checkUserConnection );

    return () => {
      document.removeEventListener( 'visibilitychange', checkUserConnection );
    };
  }, [ dispatch ] );

  return (
    <div className="App">
      {
        token ?
          <header className="App-header">
            <Router>
              <Routes>
                <Route path="*" element={<PlanningPage />} />
                <Route path="/Planning" element={<PlanningPage />} />
                {/* <Route path="/data" element={<FictiveData />} /> */}
                <Route path="/setting" element={<Setting />} />
                <Route path="/chart" element={<Chart />} />
                <Route path="/Chronogram" element={<Chronogram />} />
                <Route path="/Timegrid" element={<TimeGridView />} />
              </Routes>
            </Router>
          </header>
          :
          null
      }
    </div>
  );
}